module.exports = __webpack_public_path__ + "media/images/pla/pla8-825a321b288c9e6c3565a8e31e2734bf.jpg";